// extracted by mini-css-extract-plugin
export default {"confirmationModal":"ConfirmationModal_confirmationModal__karTI","modalContent":"ConfirmationModal_modalContent__jO0HN","modalFooter":"ConfirmationModal_modalFooter__6sOCH"};